import { emailValidator } from './constants';

export const validateMultiEmail = (
  value: string,
  isRequired: boolean,
  requiredTextError: string,
  emailFieldFormatTextError: string
) => {
  if (!value || value.length === 0) {
    return isRequired ? requiredTextError : true;
  }
  const emails = value.split(',').map((email) => email.trim());
  for (const email of emails) {
    if (!emailValidator.test(email)) {
      return emailFieldFormatTextError;
    }
  }
  return true;
};
